import { exportWarehouses, getWarehouses } from '@/apis/warehouseAPI'

import { IWarehouse } from '@/utils/types/model/warehouse'
import { CLEAR_WAREHOUSES, EXPORT_WAREHOUSES, FETCH_WAREHOUSES, SET_WAREHOUSE_LOADING } from './actions'

type TWarehouseState = {
  warehouses: IWarehouse[]
  totalRecords: number
  isLoaded: boolean
  isLoading: boolean
}

export default {
  state: {
    warehouses: [],
    totalRecords: 0,
    isLoaded: false,
    isLoading: false,
  },
  mutations: {
    [FETCH_WAREHOUSES]: (
      state: TWarehouseState,
      payload: {
        warehouses: IWarehouse[]
        totalRecords: number
      }
    ) => {
      state.warehouses = payload.warehouses
      state.totalRecords = payload.totalRecords
      state.isLoaded = true
      state.isLoading = false
    },
    [CLEAR_WAREHOUSES]: (state: TWarehouseState) => {
      state.warehouses = []
      state.totalRecords = 0
      state.isLoaded = false
      state.isLoading = false
    },
    [SET_WAREHOUSE_LOADING]: (state: TWarehouseState, loading: boolean) => {
      state.isLoading = loading
    },
  },
  actions: {
    [FETCH_WAREHOUSES]: async (
      { commit }: { commit: Function },
      payload: {
        page?: number
        limit?: number
        code?: string
        sortBy?: string
        sortType?: string
      } = {}
    ) => {
      try {
        commit(SET_WAREHOUSE_LOADING, true)
        const { page = 1, limit = 10, code = '', sortBy, sortType } = payload
        const response = await getWarehouses(page, limit, code, sortBy, sortType)
        if (!response) {
          throw new Error('No response from API')
        }
        commit(FETCH_WAREHOUSES, {
          warehouses: response.warehouseMasters || [],
          totalRecords: response.totalRecords || 0,
        })
        return response
      } catch (err) {
        commit(SET_WAREHOUSE_LOADING, false)
        throw err
      }
    },
    [EXPORT_WAREHOUSES]: async (
      { commit }: { commit: Function },
      payload: {
        sortBy?: string
        sortType?: string
      } = {}
    ) => {
      try {
        commit(SET_WAREHOUSE_LOADING, true)
        const data = {
          ...(payload.sortBy && { sortBy: payload.sortBy }),
          ...(payload.sortType && { sortType: payload.sortType }),
        }
        const response = await exportWarehouses(data)
        commit(SET_WAREHOUSE_LOADING, false)
        return response
      } catch (err) {
        commit(SET_WAREHOUSE_LOADING, false)
        throw err
      }
    },
    [CLEAR_WAREHOUSES]: ({ commit }: { commit: Function }) => {
      commit(CLEAR_WAREHOUSES)
    },
  },
  getters: {
    getWarehouses: (state: TWarehouseState) => state.warehouses,
    getWarehouseTotalRecords: (state: TWarehouseState) => state.totalRecords,
    isWarehouseLoading: (state: TWarehouseState) => state.isLoading,
    isWarehouseLoaded: (state: TWarehouseState) => state.isLoaded,
  },
}
